import axios from 'axios';

export default {
  getBiodata(params = {}) {
    return axios.get('/auth/profile', {params});
  },
  getAddress(params = {}) {
    return axios.get('/user/address', {params});
  },
  getDesease(params = {}) {
    return axios.get('/user/desease', {params});
  },
  getLocation(params = {}) {
    return axios.get('/user/location', {params});
  },
  updateBiodata(payload = {}) {
    return axios.put(`/user/biodata`, payload);
  },
  getEmergency(params = {}) {
    return axios.get('/user/emergency', {params});
  },
  updateEmergency(payload = {}) {
    return axios.post(`/user/emergency`, payload);
  },
  getHealth(params = {}) {
    return axios.get('/user/health', {params});
  },
  updateHealth(payload = {}) {
    return axios.post(`/user/health`, payload);
  },
  updateAddress(payload = {}) {
    return axios.post(`/user/address`, payload);
  },
};
